// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * SDK info
 * @internal
 */
export const SDK_INFO = {
  NAME: "opentelemetry",
  RUNTIME: "node",
  LANGUAGE: "nodejs",
};
